"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessPluginSchema = exports.CreateActivityRequestSchema = exports.CreateTokenRequestSchema = exports.GetTokenByExternalIdsSchema = exports.GetTokenByTokenIdSchema = exports.GetTokenByBusinessIdSchema = exports.GetTokenByUserIdSchema = void 0;
const ActivityUtils = __importStar(require("../model/activities"));
const TokenMisc = __importStar(require("../misc/token"));
const CredentialbMisc = __importStar(require("../misc/credential"));
const CreateTokenLib = __importStar(require("../lib/createToken"));
const zod_1 = require("zod");
//Get Token By UserId Request 
exports.GetTokenByUserIdSchema = zod_1.z.object({
    latestDetails: zod_1.z.boolean(),
    status: zod_1.z.array(zod_1.z.string()),
    type: zod_1.z.array(zod_1.z.string()),
    activityType: zod_1.z.array(zod_1.z.string()),
    latestActivityDateRange: zod_1.z.number().optional(),
    page: zod_1.z.number().optional(),
    itemCountPerPage: zod_1.z.number().optional(),
    filter: zod_1.z.object({
        mob_name: zod_1.z.string().optional(),
        birth_year_start: zod_1.z.string().optional(),
        birth_year_end: zod_1.z.string().optional(),
        isRfidExist: zod_1.z.boolean().optional(),
    }).optional()
});
//Get Token By BusinessId Request
exports.GetTokenByBusinessIdSchema = zod_1.z.object({
    latestDetails: zod_1.z.boolean(),
    status: zod_1.z.array(zod_1.z.string()),
    type: zod_1.z.array(zod_1.z.string()),
    activityType: zod_1.z.array(zod_1.z.string()),
    businessId: zod_1.z.array(zod_1.z.string()),
    page: zod_1.z.number().optional(),
    itemCountPerPage: zod_1.z.number().optional(),
    filter: zod_1.z.object({
        mob_name: zod_1.z.string().optional(),
        birth_year_start: zod_1.z.string().optional(),
        birth_year_end: zod_1.z.string().optional(),
        isRfidExist: zod_1.z.boolean().optional(),
    }).optional()
});
//Get Token By TokenId Request
exports.GetTokenByTokenIdSchema = zod_1.z.object({
    latestDetails: zod_1.z.boolean(),
    status: zod_1.z.array(zod_1.z.string()),
    tokenIds: zod_1.z.array(zod_1.z.string()),
    activityType: zod_1.z.array(zod_1.z.string()),
    type: zod_1.z.array(zod_1.z.string()).optional(),
    page: zod_1.z.number().optional(),
    itemCountPerPage: zod_1.z.number().optional(),
    filter: zod_1.z.object({
        mob_name: zod_1.z.string().optional(),
        birth_year_start: zod_1.z.string().optional(),
        birth_year_end: zod_1.z.string().optional(),
        isRfidExist: zod_1.z.boolean().optional(),
    }).optional()
});
//Get Token By ExternalId Request
exports.GetTokenByExternalIdsSchema = zod_1.z.object({
    latestDetails: zod_1.z.boolean().optional(),
    status: zod_1.z.array(zod_1.z.string()).optional(),
    activityType: zod_1.z.array(zod_1.z.string()).optional(),
    type: zod_1.z.array(zod_1.z.string()).optional(),
    externalIds: zod_1.z.array(TokenMisc.ExternalIdsSchema),
    angusAuthToken: zod_1.z.string().optional(),
    userId: zod_1.z.string().optional(),
    page: zod_1.z.number().optional(),
    itemCountPerPage: zod_1.z.number().optional(),
    filter: zod_1.z.object({
        mob_name: zod_1.z.string().optional(),
        birth_year_start: zod_1.z.string().optional(),
        birth_year_end: zod_1.z.string().optional(),
        isRfidExist: zod_1.z.boolean().optional(),
    }).optional()
});
//Create Token Request
exports.CreateTokenRequestSchema = zod_1.z.object({
    contractAddress: zod_1.z.string().optional(),
    walletAddress: zod_1.z.string().optional(),
    tokens: zod_1.z.array(CreateTokenLib.PreTokenSchema)
});
//Create Activity Request
exports.CreateActivityRequestSchema = zod_1.z.object({
    userId: zod_1.z.string().optional(),
    tokens: zod_1.z.array(zod_1.z.object({
        tokenId: zod_1.z.string().optional(),
        type: TokenMisc.tokenTypesSchema,
        externalIds: TokenMisc.ExternalIdsSchema,
        activities: zod_1.z.array(ActivityUtils.ActivitySchema)
    }))
});
exports.BusinessPluginSchema = zod_1.z.object({
    pluginId: zod_1.z.string(),
    name: zod_1.z.string(),
    credential: CredentialbMisc.CredentialSchema,
    status: zod_1.z.enum(["activated", "deactivated", "obsolete"]),
    activationDate: zod_1.z.string(),
    deactivationDate: zod_1.z.string().nullable()
});
